/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PerplayStatisticsControllerDtoUserStatisticsUserData model module.
 * @module model/PerplayStatisticsControllerDtoUserStatisticsUserData
 * @version 1.0
 */
class PerplayStatisticsControllerDtoUserStatisticsUserData {
    /**
     * Constructs a new <code>PerplayStatisticsControllerDtoUserStatisticsUserData</code>.
     * @alias module:model/PerplayStatisticsControllerDtoUserStatisticsUserData
     */
    constructor() { 
        
        PerplayStatisticsControllerDtoUserStatisticsUserData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PerplayStatisticsControllerDtoUserStatisticsUserData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayStatisticsControllerDtoUserStatisticsUserData} obj Optional instance to populate.
     * @return {module:model/PerplayStatisticsControllerDtoUserStatisticsUserData} The populated <code>PerplayStatisticsControllerDtoUserStatisticsUserData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayStatisticsControllerDtoUserStatisticsUserData();

            if (data.hasOwnProperty('targetDate')) {
                obj['targetDate'] = ApiClient.convertToType(data['targetDate'], 'Date');
            }
            if (data.hasOwnProperty('totalAccountCount')) {
                obj['totalAccountCount'] = ApiClient.convertToType(data['totalAccountCount'], 'Number');
            }
            if (data.hasOwnProperty('newAccountCount')) {
                obj['newAccountCount'] = ApiClient.convertToType(data['newAccountCount'], 'Number');
            }
            if (data.hasOwnProperty('signInAccountCount')) {
                obj['signInAccountCount'] = ApiClient.convertToType(data['signInAccountCount'], 'Number');
            }
            if (data.hasOwnProperty('totalHolderCount')) {
                obj['totalHolderCount'] = ApiClient.convertToType(data['totalHolderCount'], 'Number');
            }
            if (data.hasOwnProperty('signInHolderCount')) {
                obj['signInHolderCount'] = ApiClient.convertToType(data['signInHolderCount'], 'Number');
            }
            if (data.hasOwnProperty('activatedAccountCount')) {
                obj['activatedAccountCount'] = ApiClient.convertToType(data['activatedAccountCount'], 'Number');
            }
            if (data.hasOwnProperty('convertedHolderCount')) {
                obj['convertedHolderCount'] = ApiClient.convertToType(data['convertedHolderCount'], 'Number');
            }
            if (data.hasOwnProperty('convertedFirstHolderCount')) {
                obj['convertedFirstHolderCount'] = ApiClient.convertToType(data['convertedFirstHolderCount'], 'Number');
            }
            if (data.hasOwnProperty('convertedNonHolderCount')) {
                obj['convertedNonHolderCount'] = ApiClient.convertToType(data['convertedNonHolderCount'], 'Number');
            }
            if (data.hasOwnProperty('activatedHolderCount')) {
                obj['activatedHolderCount'] = ApiClient.convertToType(data['activatedHolderCount'], 'Number');
            }
            if (data.hasOwnProperty('suspendedAccountCount')) {
                obj['suspendedAccountCount'] = ApiClient.convertToType(data['suspendedAccountCount'], 'Number');
            }
            if (data.hasOwnProperty('suspendedHolderCount')) {
                obj['suspendedHolderCount'] = ApiClient.convertToType(data['suspendedHolderCount'], 'Number');
            }
            if (data.hasOwnProperty('firstPlayAccountCount')) {
                obj['firstPlayAccountCount'] = ApiClient.convertToType(data['firstPlayAccountCount'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayStatisticsControllerDtoUserStatisticsUserData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayStatisticsControllerDtoUserStatisticsUserData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Date} targetDate
 */
PerplayStatisticsControllerDtoUserStatisticsUserData.prototype['targetDate'] = undefined;

/**
 * @member {Number} totalAccountCount
 */
PerplayStatisticsControllerDtoUserStatisticsUserData.prototype['totalAccountCount'] = undefined;

/**
 * @member {Number} newAccountCount
 */
PerplayStatisticsControllerDtoUserStatisticsUserData.prototype['newAccountCount'] = undefined;

/**
 * @member {Number} signInAccountCount
 */
PerplayStatisticsControllerDtoUserStatisticsUserData.prototype['signInAccountCount'] = undefined;

/**
 * @member {Number} totalHolderCount
 */
PerplayStatisticsControllerDtoUserStatisticsUserData.prototype['totalHolderCount'] = undefined;

/**
 * @member {Number} signInHolderCount
 */
PerplayStatisticsControllerDtoUserStatisticsUserData.prototype['signInHolderCount'] = undefined;

/**
 * @member {Number} activatedAccountCount
 */
PerplayStatisticsControllerDtoUserStatisticsUserData.prototype['activatedAccountCount'] = undefined;

/**
 * @member {Number} convertedHolderCount
 */
PerplayStatisticsControllerDtoUserStatisticsUserData.prototype['convertedHolderCount'] = undefined;

/**
 * @member {Number} convertedFirstHolderCount
 */
PerplayStatisticsControllerDtoUserStatisticsUserData.prototype['convertedFirstHolderCount'] = undefined;

/**
 * @member {Number} convertedNonHolderCount
 */
PerplayStatisticsControllerDtoUserStatisticsUserData.prototype['convertedNonHolderCount'] = undefined;

/**
 * @member {Number} activatedHolderCount
 */
PerplayStatisticsControllerDtoUserStatisticsUserData.prototype['activatedHolderCount'] = undefined;

/**
 * @member {Number} suspendedAccountCount
 */
PerplayStatisticsControllerDtoUserStatisticsUserData.prototype['suspendedAccountCount'] = undefined;

/**
 * @member {Number} suspendedHolderCount
 */
PerplayStatisticsControllerDtoUserStatisticsUserData.prototype['suspendedHolderCount'] = undefined;

/**
 * @member {Number} firstPlayAccountCount
 */
PerplayStatisticsControllerDtoUserStatisticsUserData.prototype['firstPlayAccountCount'] = undefined;






export default PerplayStatisticsControllerDtoUserStatisticsUserData;

